export default __webpack_public_path__ + "static/media/ap.1c8bdbdc.svg";